import { hasValue, nameOf } from "@itk/typescript-utils";
import { ApiError } from "src/backend/utils/ApiError";
import { FrontendError, ItkException, LoginException } from "src/components/error-viewer/error-types";

export const isApiError = (value: unknown): value is ApiError => {
  if (typeof value === "object" && hasValue(value) && nameOf<ApiError>("status") in value && nameOf<ApiError>("url") in value) {
    return true;
  }
  return false;
};

export const isItkException = (value: unknown): value is ItkException => {
  if (typeof value === "object" && hasValue(value) && nameOf<ItkException>("CorrelationId") in value && nameOf<ItkException>("StatusCode") in value && nameOf<ItkException>("Message") in value) {
    return true;
  }
  return false;
};

export const isFrontendError = (value: unknown): value is FrontendError => {
  return typeof value === "object" && hasValue(value) && ("statusCode" satisfies keyof FrontendError) in value;
};

export const isLoginError = (value: unknown): value is LoginException => {
  if (typeof value === "object" && hasValue(value) && ("error_code" satisfies keyof LoginException) in value && ("error_description" satisfies keyof LoginException) in value) {
    return true;
  }
  return false;
};
